module.exports = __webpack_public_path__ + "img/doctor_female.ee0ccf2c.jpg";